import { useEffect, useState } from "react";

import { Image, Text } from "react-native";

import useApiUrl from "../contexts/api-url-context";

type Props = {
  url: string;
  width?: number;
  fetchDelayMs?: number;
};

export function FigmaImage({ url, width, fetchDelayMs = 0 }: Props) {
  const { file, nodes } = parseFigmaFileAndNodes(url);
  const [uri, setUri] = useState<string | null>(null);

  const apiUrl = useApiUrl();

  useEffect(() => {
    async function fetchFigmaImage(file: string, nodes: string) {
      try {
        const res = await fetch(`${apiUrl}/dev/figma/${file}/${nodes}`);
        if (!res.ok) return;
        const json = await res.json();
        return json.url as string;
      } catch (e) {
        console.log(e);
      }
    }

    async function fetchImage() {
      const imgUrl = await fetchFigmaImage(file, nodes);
      if (!imgUrl) return;
      setUri(imgUrl);
    }

    setTimeout(fetchImage, fetchDelayMs);
  }, [file, nodes, fetchDelayMs, apiUrl]);

  return uri ? (
    <Image
      source={{ uri }}
      style={{ aspectRatio: 16 / 9, width }}
      resizeMode="contain"
    />
  ) : (
    <Text>loading...</Text>
  );
}

function parseFigmaFileAndNodes(url: string) {
  const file = url.split("/file/")[1].split("/")[0];
  const nodes = url.split("node-id=")[1].split("&mode")[0].replace("-", ":");

  return { file, nodes };
}
